export function SharpAccountBalance(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.5 16.5v-7q0-.213.144-.356T7.001 9t.356.144t.143.356v7q0 .213-.144.356T6.999 17t-.356-.144T6.5 16.5m5 0v-7q0-.213.144-.356T12.001 9t.356.144t.143.356v7q0 .213-.144.356t-.357.144t-.356-.144t-.143-.356M4.039 20q-.213 0-.357-.144t-.144-.357t.144-.356t.356-.143h15.924q.212 0 .356.144t.143.357t-.143.356t-.357.143zM16.5 16.5v-7q0-.213.144-.356T17.001 9t.356.144t.143.356v7q0 .213-.144.356t-.357.144t-.356-.144t-.143-.356M20.039 7H3.918q-.158 0-.27-.11q-.11-.11-.11-.268V6.39q0-.116.058-.199q.058-.082.153-.134l7.562-3.608q.324-.161.686-.161t.69.161l7.531 3.583q.102.067.172.163t.07.219v.167q0 .19-.114.303q-.114.115-.308.115M6.18 6h11.638zm0 0h11.638l-5.55-2.635q-.134-.057-.269-.057t-.27.057z"
      ></path>
    </svg>
  )
}
